/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Image, Popover } from "antd";
import { useState } from "react";

function PopOverCrewChange(props: any) {
  const { crewDrop, memberId, allColumns, setColumns, crewLeaderId } = props;
  const [openInner, setOpenInner] = useState(false);

  const handleOpenChange = (newOpen: boolean) => {
    setOpenInner(newOpen);
  };

  const moveCrewMember = (
    memberIdToMove: string,
    newCrewId: string,
    currentCrewId: string // Renamed from crewLeaderId for clarity, as it's the current crew's ID
  ) => {
    console.log(
      `Attempting to move member ${memberIdToMove} from crew ${currentCrewId} to crew ${newCrewId}`
    );

    // 1. Find the member details
    let movingMember: any;
    const currentColumn = allColumns.find(
      (column: any) => column.id === currentCrewId
    );

    if (currentColumn) {
      movingMember = currentColumn.crewMembers.find(
        (member: any) => member.id === memberIdToMove
      );
    }

    if (!movingMember) {
      console.warn(
        `Member with ID ${memberIdToMove} not found in current crew ${currentCrewId}.`
      );
      setOpenInner(false);
      return;
    }

    // If the member is already in the target crew, do nothing
    if (currentCrewId === newCrewId) {
      console.log(
        `Member ${memberIdToMove} is already in crew ${newCrewId}. No move needed.`
      );
      setOpenInner(false);
      return;
    }

    // 2. Create an UPDATED movingMember object with the new crewLeaderId
    // This is crucial for immutability: create a new object, don't mutate the original.
    const updatedMovingMember: any = {
      ...movingMember,
      crewLeaderId: newCrewId, // Assign the new crew ID
    };

    // 3. Create the new state for allColumns by mapping over the existing ones
    const updatedColumns = allColumns.map((column: any) => {
      // If this is the current crew, remove the member from its crewMembers array
      if (column.id === currentCrewId) {
        return {
          ...column,
          crewMembers: column.crewMembers.filter(
            (member: any) => member.id !== memberIdToMove
          ),
        };
      }
      // If this is the new target crew, add the UPDATED member to its crewMembers array
      else if (column.id === newCrewId) {
        // Ensure the member isn't accidentally duplicated if they were already there
        const isAlreadyInNewCrew = column.crewMembers.some(
          (member: any) => member.id === memberIdToMove
        );
        if (!isAlreadyInNewCrew) {
          return {
            ...column,
            crewMembers: [...column.crewMembers, updatedMovingMember], // Use the updated member object
          };
        }
      }
      // For all other columns, return them as is
      return column;
    });

    console.log("Updated columns after move:", updatedColumns);
    setColumns(updatedColumns); // Update the parent's state

    setOpenInner(false); // Close the popover
  };

  return (
    <Popover
      trigger={["click"]}
      arrow={false}
      placement="right"
      open={openInner}
      onOpenChange={handleOpenChange}
      overlayClassName="crewChangePopover"
      content={
        <div>
          <h4>Move crew member to:</h4>
          {crewDrop?.map((item: any) => (
            <div
              key={item.value}
              style={{
                marginTop: 4,
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                gap: 4,
              }}
            >
              <Button
                type="text"
                onClick={(e) => {
                  e.stopPropagation();
                  moveCrewMember(memberId, item.value, crewLeaderId);
                }}
                style={{
                  padding: "6px 12px",
                  marginLeft: "-12px",
                }}
              >
                {item.label}
              </Button>
            </div>
          ))}
        </div>
      }
    >
      <Button
        className="btn-sm"
        icon={<Image src="/images/schedule/move-btn.svg" preview={false} />}
        onClick={(e) => {
          e.stopPropagation();
        }}
      />
    </Popover>
  );
}

export default PopOverCrewChange;
